<example-shell
  exampleId="column-pinning" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Column pinning"
    [columns]="advancedColumns"
    [data]="orders"
    [columnPinning]="columnPinningState"
    [columnSizing]="columnSizingState"
    [pagination]="true"
    [paginationPerPage]="5"
    [responsive]="true">
  </stackline-data-table>
</example-shell>
